import { CwtApiEntity, CwtCrudContract, CwtModel, CwtProp } from "@cawita/core-front/api";


@CwtModel({ name: 'contract-type' })
@CwtCrudContract({ path: '/contract-type', searchMapper: (s) => ({ 'name': { regexp: s } })})
export class ContractType extends CwtApiEntity {
    @CwtProp() name: string;
    @CwtProp() isLifeInsurance: boolean;
}